module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary no-print",
    attrs: {
      "flat": "",
      "dark": "",
      "mb-2": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Monthly Living Expenses " + _vm._s(_vm._f("currency")(_vm.total)))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.save
    }
  }, [_c('v-list-item-title', [_vm._v("Save for Later")])], 1), _vm._v(" "), (_vm.step == 2) ? _c('v-list-item', {
    on: {
      "click": _vm.showExample
    }
  }, [_c('v-list-item-title', [_vm._v("Show Example")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "print-only"
  }, [_c('h2', [_vm._v("Living Expense Worksheet for " + _vm._s(_vm.params.name))])]), _vm._v(" "), _c('v-container', {
    staticClass: "pa-1 pb-4",
    staticStyle: {
      "height": "100%",
      "overflow-y": "auto"
    }
  }, [_c('v-stepper', {
    staticClass: "living-expenses",
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 1,
      "step": "1"
    }
  }, [_c('div', {
    staticClass: "clickable",
    on: {
      "click": function($event) {
        _vm.step = 1
      }
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px",
      "color": "#444"
    }
  }, [_vm._v("About your household")]), _vm._v(" "), _c('small', {
    staticStyle: {
      "color": "#555"
    }
  }, [_vm._v(_vm._s(_vm.houseHoldSummary))])])]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('div', {
    staticClass: "pr-4"
  }, [_c('div', {
    staticClass: "mb-3 inset-text",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n                        This should take just a couple of minutes. To comply with government regulation, we need some information about your living expenses. Do not include rent or debts. These are assessed separately.\n                    ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Your Name/s",
      "xhide-details": ""
    },
    on: {
      "change": _vm.nameChanged
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Your Email",
      "xhide-details": ""
    },
    model: {
      value: (_vm.params.email),
      callback: function($$v) {
        _vm.$set(_vm.params, "email", $$v)
      },
      expression: "params.email"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.mode == 'invitation',
      "label": "Consultants Email"
    },
    on: {
      "input": function($event) {
        _vm.linkCopied = false
      }
    },
    model: {
      value: (_vm.params.consultant),
      callback: function($$v) {
        _vm.$set(_vm.params, "consultant", $$v)
      },
      expression: "params.consultant"
    }
  }), _vm._v(" "), (_vm.clientLinkVisible) ? _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.getClientLink($event)
      }
    }
  }, [_vm._v("Get Client Link")]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "mb-4 pa-4 grey lighten-3",
    staticStyle: {
      "border-radius": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "12px",
      "color": "#888",
      "margin-top": "-10px",
      "margin-bottom": "-10px"
    }
  }, [_vm._v("Your household")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.adultItems,
      "label": "Adults",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.adultsChanged
    },
    model: {
      value: (_vm.params.adults),
      callback: function($$v) {
        _vm.$set(_vm.params, "adults", $$v)
      },
      expression: "params.adults"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.childrenItems,
      "label": "Dependent Children",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.params.children),
      callback: function($$v) {
        _vm.$set(_vm.params, "children", $$v)
      },
      expression: "params.children"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": ['Low Income', 'Average Income', 'High Income'],
      "label": "Household Income",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.params.income),
      callback: function($$v) {
        _vm.$set(_vm.params, "income", $$v)
      },
      expression: "params.income"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": Boolean(_vm.stepOneValidation)
    },
    on: {
      "click": function($event) {
        _vm.step = 2
      }
    }
  }, [_vm._v("Continue to Next Step")]), _vm._v(" "), _c('div', {
    staticClass: "validation-error"
  }, [_vm._v(_vm._s(_vm.stepOneValidation))])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 2,
      "step": "2"
    }
  }, [_c('div', {
    class: {
      clickable: !_vm.stepOneValidation
    },
    on: {
      "click": _vm.stepTwoClicked
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px",
      "color": "#444"
    }
  }, [_vm._v("Monthly Expenses")]), _vm._v(" "), _c('small', {
    staticStyle: {
      "color": "#555"
    }
  }, [_vm._v(_vm._s(_vm.stepTwoSubtitle))])])]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('div', {
    staticClass: "pl-3"
  }, _vm._l((_vm.expenses), function(expense, index) {
    return _c('LivingExpense', {
      key: index,
      attrs: {
        "expense": expense
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "text-align": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 1
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": Boolean(_vm.stepTwoValidation),
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.step = 3
      }
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('div', {
    staticClass: "validation-error"
  }, [_vm._v(_vm._s(_vm.stepTwoValidation))])], 1)]), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.submitted,
      "step": "3"
    }
  }, [_c('div', {
    class: {
      clickable: !_vm.stepTwoValidation
    },
    on: {
      "click": _vm.stepThreeClicked
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px",
      "color": "#444"
    }
  }, [_vm._v("Submit your information")]), _vm._v(" "), _c('small', {
    staticStyle: {
      "color": "#555"
    }
  })])]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [(_vm.submitted) ? _c('div', {
    staticClass: "pa-2 grey--text text--darken-2",
    attrs: {
      "max-width": "500px"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "50px",
      "margin-right": "10px",
      "float": "left"
    },
    attrs: {
      "color": "green"
    }
  }, [_vm._v("check_circle_outline")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#999",
      "font-weight": "200"
    }
  }, [_vm._v("Thank you.")]), _vm._v("Your answers have been recorded. You may close this window. \n        ")], 1) : [(!_vm.totalWithinRange) ? _c('div', {
    staticStyle: {
      "max-width": "500px"
    }
  }, [(_vm.totalRangeError) ? _c('div', {
    staticClass: "no-print grey--text text--darken-1"
  }, [_c('v-icon', {
    staticStyle: {
      "float": "left",
      "margin-right": "10px"
    },
    attrs: {
      "color": "red lighten-2"
    }
  }, [_vm._v("report_problem")]), _vm._v(" "), _c('span', [_vm._v("\n                        Your total living expenses of " + _vm._s(_vm.total) + " is " + _vm._s(_vm.totalHigherOrLower) + " than expected, Your lender will require an explanation why. Otherwise you can\n                        "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.step = 2
      }
    }
  }, [_vm._v("go back and review your answers")])])], 1) : _vm._e(), _vm._v(" "), _c('v-textarea', {
    staticClass: "no-print mt-2",
    attrs: {
      "outline": "",
      "label": "",
      "single-line": "",
      "rows": 2
    },
    model: {
      value: (_vm.params.explanation),
      callback: function($$v) {
        _vm.$set(_vm.params, "explanation", $$v)
      },
      expression: "params.explanation"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.submitted) ? _c('div', {
    staticClass: "pa-3 mb-3 elevation-2",
    staticStyle: {
      "border": "solid 1px #ccc",
      "border-radius": "8px",
      "max-width": "500px"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": _vm.totalRangeError
    },
    on: {
      "click": _vm.sendSubmission
    }
  }, [_vm._v("Send Now")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "color": "#777"
    }
  }, [_vm._v("Ready to Send")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "40px",
      "font-weight": "600",
      "display": "inline-block"
    }
  }, [_vm._v("To: ")]), _vm._v(_vm._s(this.params.consultant)), _c('br'), _vm._v(" "), (this.params.email) ? [_c('div', {
    staticStyle: {
      "width": "40px",
      "font-weight": "600",
      "display": "inline-block"
    }
  }, [_vm._v("Cc: ")]), _vm._v(_vm._s(this.params.email) + "\n                ")] : _vm._e()], 2) : _vm._e()], _vm._v(" "), _c('table', {
    ref: "expenses",
    staticStyle: {
      "width": "100%",
      "max-width": "500px",
      "border-collapse": "collapse"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "solid 1px #bbb",
      "padding": "8px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.params.name))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "solid 1px #bbb",
      "padding": "8px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.houseHoldSummary))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "solid 1px #bbb",
      "padding": "8px"
    }
  }, [_c('b', [_vm._v("Living Expenses")]), _vm._v(" "), (_vm.params.explanation) ? _c('div', [_vm._v("\n                        " + _vm._s(_vm.params.explanation) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "solid 1px #bbb",
      "padding": "8px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.total)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "solid 1px #bbb",
      "padding": "8px"
    }
  }, [_c('b', [_vm._v("Breakdown")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "solid 1px #bbb",
      "padding": "8px"
    },
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _vm._l((_vm.expenses), function(expense) {
    return [_c('tr', {
      key: expense.name
    }, [_c('td', {
      staticStyle: {
        "border-bottom": "solid 1px #bbb",
        "padding": "8px"
      }
    }, [_c('b', [_vm._v(_vm._s(expense.name))]), _vm._v(" "), (expense.explanation) ? _c('div', [_vm._v("\n                            " + _vm._s(expense.explanation) + "\n                        ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-bottom": "solid 1px #bbb",
        "padding": "8px"
      },
      attrs: {
        "align": "right",
        "valign": "top"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(expense.value)) + "\n                        "), (expense.na) ? _c('span', [_vm._v("Not Applicable")]) : _vm._e()])])]
  })], 2)], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9918ab98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LivingExpenses/LivingExpenses.vue
// module id = 2632
// module chunks = 1